export const config = {
  referral: {
    expiryInDays: (window.referral || {}).expiryInDays,
    key: (window.referral || {}).key,
    notifyAPIUrl: 'https://artists-portal.elephantstock.net/api/referral/visits'
  },
  session: {
    expiryInDays: 240 / 24 / 60
  },
  TYPE: {
    UTM: 'utm',
    PARTNERS: 'partners',
    REFERRAL: 'referral',
    DIRECT: 'direct'
  }
}